import type { NextPage } from 'next'
import { ThankYouRequest } from '@/client/modules/ThankYouRequest'
import { ThankYouRequestProps } from '@/client/modules/ThankYouRequest/types'
import { getCMSContent } from '@/client/utils'

const ThankYouRequestPage: NextPage<ThankYouRequestProps> = (data) => <ThankYouRequest {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'REQUEST_THANK_YOU')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default ThankYouRequestPage
